export const amounts = [10, 20, 50];
